import apiClient from './apiClient';

export interface ActiveUsersMetrics {
  dau: number;
  wau: number;
  mau: number;
  stickiness: number;
}

export interface RegisteredUsersMetrics {
  total: number;
  trend: { month: string; count: number }[];
}

export interface TopEvent {
  event: string;
  total: number;
}

export interface FeatureAdoption {
  event: string;
  users: number;
  pct: number;
}

export interface DayBreakdown {
  day: string;
  newUsers: number;
  returningUsers: number;
}

export interface FunnelStep {
  event: string;
  label: string;
  count: number;
  conversionRate: number;
}

export interface CohortSegment {
  segment: string;
  users: number;
}

export const getActiveUsers = async (): Promise<ActiveUsersMetrics> => {
  const response = await apiClient.get('/admin/analytics/active-users');
  return response.data;
};

export const getRegisteredUsers = async (): Promise<RegisteredUsersMetrics> => {
  const response = await apiClient.get('/admin/analytics/registered-users');
  return response.data;
};

export const getTopEvents = async (): Promise<TopEvent[]> => {
  const response = await apiClient.get('/admin/analytics/top-events');
  return response.data;
};

export const getFeatureAdoption = async (): Promise<FeatureAdoption[]> => {
  const response = await apiClient.get('/admin/analytics/feature-adoption');
  return response.data;
};

export const getNewVsReturning = async (): Promise<DayBreakdown[]> => {
  const response = await apiClient.get('/admin/analytics/new-vs-returning');
  return response.data;
};

export const getActivationFunnel = async (): Promise<FunnelStep[]> => {
  const response = await apiClient.get('/admin/analytics/activation-funnel');
  return response.data;
};

export const getCohorts = async (): Promise<CohortSegment[]> => {
  const response = await apiClient.get('/admin/analytics/cohorts');
  return response.data;
};
